import { createRouter, createWebHistory } from 'vue-router';
import ErrorPage from '../views/ErrorPage.vue';
import SmsPage from '../views/SmsPage.vue';
import useLocaleStore from '../store/locale';
import useSmsOptinStatusStore from '../store/smsOptInStatus';
import useOriginalQueryStore from '../store/originalQuery';
import useUserActionStore from '../store/userAction';
import { UserActionEnum } from '../constants';

let appInst;

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/:locale/sms/',
      component: SmsPage,
      name: 'SmsPage',
      meta: {
        title: () => {
          const { translations } = appInst.config.globalProperties.$staticGlobals;

          return `Garmin | ${translations.programTitle}`;
        },
      },
    },
    {
      path: '/',
      name: 'Root',
      redirect: '/en-US/sms',
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'ErrorPage',
      component: ErrorPage,
      props: { errorCode: '404' },
      meta: {
        title: () => {
          const { translations } = appInst.config.globalProperties.$staticGlobals;

          return `Garmin | ${translations.programTitle}`;
        },
      },
    },
  ],
});

export default {
  instance: router,
  install(app) {
    appInst = app;

    router.install(app);

    // use beforeEach route guard to set the language in the store
    router.beforeEach(async (to, from, next) => {
      const { locale } = to.params; // grabs the locale from the url

      const localeStore = useLocaleStore();
      const smsOptinStatusStore = useSmsOptinStatusStore();
      const originalQueryStore = useOriginalQueryStore();
      const userActionStore = useUserActionStore();

      // loads the locale into the store
      localeStore.loadLocale(locale);
      // loads the sms opt in status from app initialization into the store
      smsOptinStatusStore.loadSmsOptInStatus();
      // loads the original query string parameters from app initialization into the store
      originalQueryStore.loadOriginalQuery();
      // initializes the user action
      userActionStore.loadUserAction(UserActionEnum.SMS_PAGE_OPEN);
      // set the title of the page using the meta data
      window.document.title = to.meta.title();

      next();
    });
  },
};
